import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Icon } from '@folio/stripes/components';
import StatusBox from './StatusBox';
import StatusIndicator from './StatusIndicator';
import ExpandableItemsDetails from './ExpandableItemsDetails';
import css from './SafeDeleteInstancePage.css';

const CheckResultItem = ({
  count,
  itemType,
  messageId,
  defaultMessage,
  availableCount,
  unavailableCount,
  unavailableItems = [],
  showDetails = false,
}) => {
  const hasItems = count > 0;
  const isItemsCheck = itemType === 'items';

  // For items, success means all items are available (unavailableCount === 0)
  // For holdings, success means no holdings (count === 0)
  const isSuccess = isItemsCheck
    ? hasItems && unavailableCount === 0
    : !hasItems;

  const getMessageValues = () => {
    if (isItemsCheck && hasItems) {
      return {
        count,
        availableCount,
        unavailableCount,
      };
    }
    return { count };
  };

  const getMessageId = () => {
    if (
      isItemsCheck &&
      hasItems &&
      (availableCount > 0 || unavailableCount > 0)
    ) {
      return 'ui-plugin-inventory-templates.safeDelete.itemsCheckDetailed';
    }
    return messageId;
  };

  const getDefaultMessage = () => {
    if (
      isItemsCheck &&
      hasItems &&
      (availableCount > 0 || unavailableCount > 0)
    ) {
      return 'Items: {count} found ({availableCount} Available, {unavailableCount} Unavailable)';
    }
    return defaultMessage;
  };

  return (
    <div>
      <StatusBox isSuccess={isSuccess} className={css.checkResultItem}>
        <div className={css.checkResultItemContent}>
          <StatusIndicator isSuccess={isSuccess} />
          <div className={css.checkResultItemText}>
            <FormattedMessage
              id={getMessageId()}
              defaultMessage={getDefaultMessage()}
              values={getMessageValues()}
            />
          </div>
          <Icon
            icon={isSuccess ? 'check-circle' : 'times-circle'}
            size="small"
            className={isSuccess ? css.successIcon : css.errorIcon}
          />
        </div>
      </StatusBox>

      {showDetails && isItemsCheck && unavailableItems.length > 0 && (
        <ExpandableItemsDetails unavailableItems={unavailableItems} />
      )}
    </div>
  );
};

CheckResultItem.propTypes = {
  count: PropTypes.number.isRequired,
  itemType: PropTypes.string.isRequired,
  messageId: PropTypes.string.isRequired,
  defaultMessage: PropTypes.string.isRequired,
  availableCount: PropTypes.number,
  unavailableCount: PropTypes.number,
  unavailableItems: PropTypes.arrayOf(PropTypes.object),
  showDetails: PropTypes.bool,
};

export default CheckResultItem;
